import React, { memo, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { Typography, MenuItem, MenuList, ListItemIcon } from '@mui/material'
import { PopperMenu, UserIcon, SecurityIcon, LogoutIcon } from '../components'
import { translate } from '../i18n'
import { AccountMenuProps } from './AccountMenu.types'

function AccountMenu({ anchorRef, onClose, onSignOut }: AccountMenuProps) {
    const handleListKeyDown = useCallback(
        (event: React.KeyboardEvent) => {
            if (event.key === 'Tab' || event.key === 'Escape') {
                event.preventDefault()
                onClose()
            }
        },
        [onClose]
    )

    return (
        <PopperMenu
            placement="bottom-end"
            anchorRef={anchorRef}
            onClose={onClose}
        >
            <MenuList
                autoFocusItem
                id="account-menu"
                onKeyDown={handleListKeyDown}
            >
                <MenuItem component={Link} to="/profile" onClick={onClose}>
                    <ListItemIcon>
                        <UserIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        {translate('users.profile.title')}
                    </Typography>
                </MenuItem>
                <MenuItem component={Link} to="/security" onClick={onClose}>
                    <ListItemIcon>
                        <SecurityIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        {translate('users.security.title')}
                    </Typography>
                </MenuItem>
                <MenuItem onClick={onSignOut}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" color="secondary" />
                    </ListItemIcon>
                    <Typography variant="inherit">
                        {translate('buttons.signout')}
                    </Typography>
                </MenuItem>
            </MenuList>
        </PopperMenu>
    )
}

export default memo(AccountMenu)
